<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav :selectedLanguage="selectedLanguage" :page="pageName" />
  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section class="mod-page-content">
        <div class="mod-header">
          <h1>{{ modName }} APK Download Latest Version 2026</h1>
          <p class="mod-description">{{ modDescription }}</p>
        </div>
        <div class="download-button-section">
          <button class="download-btn" @click="download()">
            <img src="@/assets/android.webp" alt="android icon">
            Download {{ modName }} APK ({{ modSize }})
          </button>
        </div>
        <div class="app-info-section">
          <h2>App Information</h2>
          <div class="app-info-table">
            <table>
              <tbody>
                <tr><th>Name:</th><td>{{ modName }}</td></tr>
                <tr><th>Size:</th><td>{{ modSize }}</td></tr>
                <tr><th>Version:</th><td>{{ modVersion }}</td></tr>
                <tr><th>Release Date:</th><td>{{ modReleaseDate }}</td></tr>
                <tr><th>System:</th><td>Android {{ modAndroidVersion }}+</td></tr>
                <tr><th>Price:</th><td>Free</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <section class="mod-features">
          <h2>What is {{ modName }}</h2>
          <p>{{ whatIsMod }}</p>
        </section>
        <section class="mod-features">
          <h2>{{ modName }} Key Features</h2>
          <ul><li v-for="(feature, index) in modFeatures" :key="index">{{ feature }}</li></ul>
        </section>
        <section class="mod-comparison">
          <h2>{{ modName }} vs GBWhatsApp</h2>
          <p>{{ modVsGbwhatsapp }}</p>
        </section>
        <section class="mod-download-guide">
          <h2>How to Download {{ modName }}</h2>
          <ol>
            <li>Backup your chats from your current WhatsApp via Settings > Chats > Chat Backup.</li>
            <li>Enable Unknown Sources in your phone settings (Settings > Security > Install unknown apps).</li>
            <li>Click the download button above</li>
            <li>Open the APK file and tap Install.</li>
            <li>Verify your phone number after installation.</li>
          </ol>
        </section>
        <section class="mod-privacy">
          <h2>{{ modName }} Privacy Settings</h2>
          <p>{{ modPrivacy }}</p>
        </section>
        <section class="mod-safety">
          <h2>Is {{ modName }} Safe to Use</h2>
          <p>{{ modSafety }}</p>
        </section>
        <section class="mod-faq">
          <h2>Frequently Asked Questions</h2>
          <div class="faq-item"><h3>Can I use {{ modName }} alongside <a href="/" class="jump-url">GBWhatsApp</a>?</h3><p>Yes, you can install multiple WhatsApp mods on your device, but each requires a different phone number.</p></div>
          <div class="faq-item"><h3>Will my chat history transfer to {{ modName }}?</h3><p>Yes, you can restore your chat backup when setting up {{ modName }} for the first time.</p></div>
          <div class="faq-item"><h3>Does {{ modName }} support dark mode?</h3><p>Yes, {{ modName }} includes built-in dark mode themes.</p></div>
        </section>
        <section class="mod-alternatives">
          <h2>Best {{ modName }} Alternatives</h2>
          <p>If you're looking for other WhatsApp mods:</p>
          <ul class="alternative-links">
            <li><a href="/fmwhatsapp/">FMWhatsApp</a> - Popular WhatsApp modification</li>
            <li><a href="/yowhatsapp/">YoWhatsApp</a> - Extensive customization</li>
            <li><a href="/whatsapp-plus/">WhatsApp Plus</a> - Original modification</li>
          </ul>
        </section>
        <div class="download-button-section bottom">
          <button class="download-btn" @click="download()">
            <img src="@/assets/android.webp" alt="android icon">
            Download {{ modName }} APK ({{ modSize }})
          </button>
        </div>
      </section>
    </article>
  </div>
</div>
</template>
<script>
import '@/css/base.scss'; import '@/css/index.scss'; import HeadNav from '@/components/HeadNav.vue';
import modApkMixin from '@/mixins/modApk.js';
export default {
  name: 'Ogwhatsapp', mixins: [modApkMixin], components: { HeadNav },
  data() {
    return {
      pageName: 'ogwhatsapp', selectedLanguage: 'en', apk: null, from: 'og', filename: 'og',
      modName: 'OGWhatsApp', modDescription: 'Download OGWhatsApp APK with unique features and enhanced privacy controls.',
      modSize: '62MB', modVersion: 'v18.60', modReleaseDate: 'Mar, 2026', modAndroidVersion: '5.0',
      whatIsMod: 'OGWhatsApp is a modified version of WhatsApp that brings unique features and enhanced privacy controls to users.',
      modFeatures: ['Privacy Controls: Advanced hiding options for online status and read receipts', 'Custom Themes: Various options', 'Extended theme Media Sharing: Share larger files', 'Anti-Delete: View deleted messages', 'App Lock: Built-in security features', 'Multiple Accounts: Use multiple accounts', 'Status Downloader: Save status videos and images', 'No Ads: Ad-free experience'],
      modVsGbwhatsapp: 'OGWhatsApp offers similar features to GBWhatsApp but with a different interface design. Both are reliable choices for WhatsApp customization.',
      modPrivacy: 'OGWhatsApp provides comprehensive privacy settings to hide your online status, read receipts, and typing indicators.',
      modSafety: 'OGWhatsApp is generally safe with anti-ban features. Download from trusted sources.'
    };
  },
};
</script>
<style lang="scss" scoped>
.mod-page-content { max-width: 1080px; margin: 1rem auto; padding: 40px 20px; background: #fff; border-radius: 12px; }
.mod-header { text-align: center; margin-bottom: 40px; }
.mod-header h1 { color: #25D366; font-size: 2.5em; font-weight: 700; margin-bottom: 20px; }
.mod-description { font-size: 1.1em; color: #666; line-height: 1.6; }
.download-button-section { text-align: center; margin: 40px 0; }
.download-btn { display: inline-flex; align-items: center; gap: 12px; background: linear-gradient(135deg, #25D366 0%, #128C7E 100%); color: white; border: none; padding: 18px 32px; border-radius: 50px; font-size: 18px; font-weight: 600; cursor: pointer; box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3); }
.download-btn:hover { transform: translateY(-2px); }
.download-btn img { width: 24px; height: 24px; filter: brightness(0) invert(1); }
.app-info-section { margin: 40px 0; }
.app-info-section h2 { color: #25D366; font-size: 1.8em; margin-bottom: 20px; text-align: center; }
.app-info-table { background: #f8f9fa; border-radius: 12px; overflow: hidden; }
.app-info-table table { width: 100%; border-collapse: collapse; }
.app-info-table th, .app-info-table td { padding: 16px 20px; text-align: left; border-bottom: 1px solid #e9ecef; }
.app-info-table th { background: #e9f7ef; color: #128C7E; font-weight: 600; width: 40%; }
.mod-features, .mod-comparison, .mod-download-guide, .mod-privacy, .mod-safety, .mod-faq, .mod-alternatives { margin: 50px 0; text-align: left; }
.mod-features h2, .mod-comparison h2, .mod-download-guide h2, .mod-privacy h2, .mod-safety h2, .mod-faq h2, .mod-alternatives h2 { color: #25D366; font-size: 1.8em; margin-bottom: 20px; }
.mod-features p, .mod-comparison p, .mod-privacy p, .mod-safety p, .mod-alternatives p { line-height: 1.8; font-size: 16px; color: #444; text-align: left; }
.mod-features ul { list-style: none; padding: 0; }
.mod-features ul li { padding: 12px 0 12px 20px; position: relative; }
.mod-features ul li::before { content: "✓"; position: absolute; left: 0; color: #25D366; font-weight: bold; }
.mod-download-guide ol { background: #f8f9fa; padding: 20px 24px 20px 28px; border-radius: 12px; border-left: 4px solid #25D366; text-align: left; }
.mod-download-guide li { margin-bottom: 15px; line-height: 1.6; font-size: 16px; padding-left: 0.4em; }
.faq-item { background: #f8f9fa; padding: 20px; border-radius: 8px; margin-bottom: 20px; text-align: left; }
.faq-item h3 { color: #128C7E; font-size: 1.1em; margin-bottom: 10px; }
.faq-item p { line-height: 1.6; color: #666; }
.alternative-links { list-style: none; padding: 0; }
.alternative-links li { padding: 12px 0 12px 20px; position: relative; }
.alternative-links li::before { content: "→"; position: absolute; left: 0; color: #25D366; }
.alternative-links a { color: #25D366; text-decoration: none; font-weight: 600; }

@media (max-width: 768px) {
  .mod-page-content { padding: 20px 15px; }
  .mod-header h1 { font-size: 1.8em; }
  .download-btn { padding: 15px 25px; font-size: 16px; width: 100%; max-width: 320px; min-height: 48px; min-width: 48px; justify-content: center; }
  .app-info-table { overflow-x: auto; display: block; -webkit-overflow-scrolling: touch; }
  .app-info-table th, .app-info-table td { padding: 12px 15px; font-size: 14px; overflow-wrap: break-word; word-break: break-word; }
  .mod-description { overflow-wrap: break-word; word-break: break-word; }
  .mod-features ul li { font-size: 15px; }
  .mod-download-guide li { font-size: 14px; }
  .faq-item { padding: 16px 15px; h3 { font-size: 1em; } p { font-size: 14px; } }
}
</style>
